<template>
   <div>

     <Navbar></Navbar>

     <b-container fluid class="mt-5">

       <div class="mb-4">

          <b-col sm="12" lg="12" xl="12">
            <b-form-input v-model="searchCompanies" size="lg" placeholder="Søk leverandør eller tjenester.."></b-form-input>
          </b-col>

        </div>

          <b-card-group columns>
            
            <b-card v-for="company in filterBy(companies, searchCompanies)" :key="company.id"
            >

              <template #header>
                <b-row>

                  <b-col><h5 class="mb-0">{{company.name}}</h5></b-col>

                  <b-col><b-button class="float-right" variant="primary" size="sm" @click="goOrder(company.id)">Bestill</b-button> </b-col>
                </b-row>
       
              </template>

              <b-card-text>

                <b-img center class="header-img-supplier" :src="company.logo.url" fluid alt="Responsive image"></b-img>
                <br>


                
                <div class="mt-3">
                {{company.description}}
                </div>

              </b-card-text>

              <template #footer>

                <b-row>
                  <b-col>
                    <b-button class="" variant="outline-primary" size="small" @click="goOrder(company.id)">Vis mer</b-button>   
                  </b-col>
     
                  <b-col>
                    <div class="text-right">
                      <b-badge class="ml-1 text-center" v-for="service in company.services"
                        :key="service.value" pill variant="primary">{{service.text}}
                      </b-badge>
                    </div>
                  </b-col>
                </b-row>

              
              </template>

            </b-card>


           </b-card-group>
   
      </b-container>

     


  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import axios from "axios";
import Vue2Filters from "vue2-filters";

export default {
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      companies: [],
      searchCompanies: ""
    };
  },
  mixins: [Vue2Filters.mixin],
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    filteredcompanies() {
      return this.companies.filter((companies) => {
        return companies.match(this.searchCompanies);
      });
    },
  },
  methods: {
    getCompanies() {
        axios
          .get("https://api.eines-as.no/companies?_where[type]=Supplier")
          .then((res) => {
            this.companies = res.data;
          });
    },
    goLogin() {
      this.$router.push("/login");
    },
    goRegister() {
      this.$router.push("/register");
    },
    goOrder(companyId) {
      this.$router.push("/customer/neworder?supplier_company=" + companyId);
    },
    logout: function () {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    },

    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },
    changeLanguageNO() {
      this.$i18n.locale = "no";
    },
    changeLanguageEN() {
      this.$i18n.locale = "en";
    },
    getIPlocation() {
      axios.get("https://ipinfo.io/json").then((res) => {
        var locale = res.data;

        if (locale.country != "NO") {
          this.$i18n.locale = "en";
        }
      });
    },
  },
  created: function () {
    this.getCompanies()
  },
};
</script>


<style lang="css">
@import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";

/*
 * Base structure
 */

.header-img-supplier {
  max-width: 250px !important;
  max-height: 180px !important;
  align-content: center;
}

.hero-image {
  height: 100%;
  background-color: #333;
  height: 100vh; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  display: -ms-flexbox;
  display: flex;
  color: #fff;
  box-shadow: inset 0 0 5rem rgba(0, 0, 0, 0.8);
}

.hero-slider {
  padding-top: 30vh;
}

h1,
.h1 {
  font-size: 3rem;
}

.text-color-white {
  color: white !important;
}
</style>